/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Past/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Icon from './Icon/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Past({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Indicator/Past"
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let eventAppointmentTypeColorIdValueData = fromData.useDataFormat({ viewPath,
context: 'event',
path: 'appointment.type.color_id',
format: fromFormat.appointmentTypeColor,
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="Past.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Past.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-1-aUwE': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical1}`}
/>
<div
  data-testid="Past.Vertical:2"
  data-view-path={viewPath}
 style={{'--bc-2-aUwE': eventAppointmentTypeColorIdValueData,'--bblr-3-aUwE': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbrr-4-aUwE': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btlr-5-aUwE': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btrr-6-aUwE': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--oc-7-aUwE': typeof dtColorsWhite === 'number' ? `${dtColorsWhite}px` : dtColorsWhite}}
 className={`views-block ${styles.Vertical2}`}
>
<Icon
  viewPath={`${viewPath}/Icon`}
/>
</div>
</div>
{children}
</React.Fragment>)
}